import flow from './default';

import { StakeholderBlock } from '@/flow/blocks/recollection/Stakeholder.block';

export function recollectionFlow(options) {
  return typeof flow === 'function' ? flow({ StakeholderBlock, ...options }) : flow;
}
